var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"container w-640"},[_c('ResetPasswordForm',{attrs:{"to":{name: 'login'}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }